import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/Services/app.config';
import { TrfaSourceMasterService } from 'src/Services/trfa-source-master.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-Source-add-update',
  templateUrl: './Source-add-update.component.html',
  styleUrls: ['./Source-add-update.component.css']
})
export class SourceAddUpdateComponent implements OnInit {

  SourceMasterForm: FormGroup;
  userID: any;
  appModel: any;
  SelectedTool: string;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  tokenKey: any;
  isSubmit: boolean = false;
  isEdit: boolean = false;
  pattern = /^[ a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+(\s{0,1}[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ])*$/

  constructor(private readonly _fb: FormBuilder,
    private readonly checkAuth: CheckAuth,
    private readonly activedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly trfaSourceMaster: TrfaSourceMasterService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {

    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = this.sessionStorageService.getAdminUserId();
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }
  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.isSubmit = false;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SourceMasterForm = this._fb.group({
      SourceTypeId: 0,
      SourceName: ['', Validators.required],
      sortOrder: ['', Validators.required],
    })
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.isEdit = true;
          this.GetSourceById(params['id']);
        }
      }
    });
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  cancelSourceMaster() {
    let navigation = '/admin/' + this.SelectedTool + '/source';
    this.router.navigate([navigation]);
  }

  GetSourceById(SourceTypeId: number) {
    this.trfaSourceMaster.GetSourceById(this.tokenKey, parseInt(SourceTypeId.toString())).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.SourceMasterForm.patchValue({
            SourceTypeId: result['source'].sourceTypeId,
            SourceName: result['source'].sourceName,
            sortOrder: result['source'].sortOrder
          });
        }
      });
  }

  save() {
    this.isSubmit = true;
    let data = this.SourceMasterForm.value;
    if (!this.SourceMasterForm.valid || !data.SourceName.trim())
      return
    let value = {
      SourceTypeId: data.SourceTypeId,
      SourceName: data.SourceName.trim(),
      sortOrder: data.sortOrder
    }
    this.trfaSourceMaster.SourceAddUpdate(this.tokenKey, value).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (result['message'] != "") {
            this.showMessage(result['message'], 'Warning', 'warning')
          } else {

            if (data.SourceTypeId > 0)
              this.showMessage('Source updated successfully', 'Success', 'success');
            else
              this.showMessage('Source saved successfully', 'Success', 'success');
            this.router.navigate(['/admin/' + this.SelectedTool + '/source']);
          }
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }
}
